export const CHARTCOLORS = {
    COLOR1: "#D50000",
    COLOR2: "#DD4242",
    COLOR3: "#571A1A",
    COLOR4: "#570000",
    COLOR5: "#990000",
    BLACK: "#000",
    WHITE: "#fff",
}